import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-094d9efd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "history"
};
const _hoisted_2 = ["src"];
export default /*#__PURE__*/_defineComponent({
  __name: 'company-history',
  setup(__props) {
    const historyList = ["https://img2.qiuwenxinli.com/official-website/about-us/history-1.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-2.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-3.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-4.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-5.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-6.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-7.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-8.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-9.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-10.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/history-11.jpg"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(historyList, (item, index) => {
        return _createElementVNode("div", {
          class: "history-item",
          key: index
        }, [_createElementVNode("img", {
          class: "history-item-img",
          src: item
        }, null, 8, _hoisted_2)]);
      }), 64))]);
    };
  }
});